import { render, staticRenderFns } from "./HrSalaryInsBear.vue?vue&type=template&id=22d722c8&scoped=true&"
import script from "./HrSalaryInsBear.vue?vue&type=script&lang=js&"
export * from "./HrSalaryInsBear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d722c8",
  null
  
)

export default component.exports